module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-bottom-stone-path-background-remnants.2b21ddf1.png";